<template>
  <div
    class="absolute rounded-full"
    :class="[
      {
        'bg-success': status === 'active',
        'bg-yellow-500': status === 'busy' || status === 'suspend',
        'bg-destructive': status === 'inactive',
        'border-2': border,
        '-right-px -bottom-px h-3 w-3': size === 'sm',
        '-right-px -bottom-px h-4 w-4': size === 'md',
        '-right-0.5 -bottom-0.5 h-5 w-5': size === 'lg',
      },
      borderColor,
    ]"
  ></div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    status: 'active' | 'inactive' | 'busy' | 'new' | 'suspend';
    background?: 'block' | 'body';
    border?: boolean;
    size?: 'sm' | 'md' | 'lg';
  }>(),
  { background: 'block', border: true, size: 'md' },
);

const borderColor = computed(() => {
  if (props.border) {
    return props.background === 'block' ? 'border-(--card)' : 'border-(--background)';
  }
  return 'border-transparent';
});
</script>
